var map = {
	"./AWSSAA3.png": 166,
	"./AzureDE.png": 167,
	"./address_image.svg": 168,
	"./animated_ashutosh.png": 169,
	"./animated_logo.svg": 170,
	"./blogs_image.svg": 171,
	"./cloud_infrastructure.svg": 172,
	"./codeInLogo.png": 173,
	"./contactMail.png": 174,
	"./coursera_logo.png": 175,
	"./croissant.jpeg": 176,
	"./data_science.svg": 177,
	"./deeplearning_ai_logo.png": 178,
	"./delhivery_logo.png": 179,
	"./developerActivity.svg": 180,
	"./dockerkubernetes.png": 181,
	"./dsc_logo.png": 182,
	"./education.svg": 183,
	"./experience.svg": 184,
	"./feelingProud.svg": 185,
	"./freecopy_logo.png": 186,
	"./fullstack.svg": 187,
	"./gcp_logo.png": 188,
	"./github_logo.png": 189,
	"./googleAssistant.jpg": 190,
	"./googleAssistant.svg": 191,
	"./google_logo.png": 192,
	"./homepage1.svg": 193,
	"./homepage2.svg": 194,
	"./homepage3.svg": 195,
	"./homepage4.svg": 196,
	"./ibm_logo.png": 197,
	"./iiitk_logo.png": 198,
	"./intel_logo.jpg": 199,
	"./iu_logo.png": 200,
	"./jsFramework.svg": 201,
	"./legato_logo.png": 202,
	"./manOnTable.svg": 203,
	"./microsoft_logo.png": 204,
	"./mozilla_logo.png": 205,
	"./muffito_logo.png": 206,
	"./nextuLogo.jpg": 207,
	"./nptel_logo.png": 208,
	"./portfolio.gif": 209,
	"./profile.jpg": 210,
	"./programmer.svg": 211,
	"./projects_image.svg": 212,
	"./pwa.png": 213,
	"./saayaHealthLogo.png": 214,
	"./stanford_logo.png": 215,
	"./sureify.jpg": 216,
	"./talksCardBack.svg": 217,
	"./talksCardBackAlt.svg": 218,
	"./tesla.jpg": 219,
	"./tiktok_logo.png": 220,
	"./ui_ux_design.svg": 221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;